import { Flex, IconButton, Text } from '@chakra-ui/core'
import React from 'react'
import { ArrowLeft } from 'react-feather'
import { useHistory } from 'react-router-dom'

type BackButtonProps = {
  onClick?: React.MouseEventHandler<HTMLDivElement>
  title?: string
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, title }) => {
  const history = useHistory()
  return (
    <Flex cursor="pointer" align="center" onClick={onClick ? onClick : () => history.goBack()}>
      <IconButton
        aria-label="Go Back"
        bg="white"
        mr={3}
        as={ArrowLeft}
        size="md"
        p={2}
        borderRadius=".5rem"
        color="gray.600"
      />
      <Text color="gray.500" transition="all .3s ease" fontSize="xs">
        {title}
      </Text>
    </Flex>
  )
}
BackButton.defaultProps = {
  title: 'Go Back'
}
export default BackButton
